// extracted by mini-css-extract-plugin
module.exports = {"starBlack":"starIcon_starBlack__wwYB1","icon":"starIcon_icon__EJXxq","buttonIcon":"starIcon_buttonIcon__a8MSa"};